
/* ====================================
 * 1) Add .always-hide to <head>
 * ===================================== */
(function(){
  var style = document.createElement("style");
  style.textContent = ".always-hide { display: none !important; }";
  document.head.appendChild(style);
})();

/* ====================================
 * Alt image hint map (parsed from Liquid JSON)
 * ===================================== */
var ALT_IMAGE_HINT_MAP = (function(){
  var el = document.getElementById("alt-image-hint-map");
  if (!el) return Object.freeze({});
  try {
    var raw = JSON.parse(el.textContent || "{}");
    var out = {};
    for (var id in raw) {
      if (!Object.prototype.hasOwnProperty.call(raw, id)) continue;
      var v = raw[id];
      if (Array.isArray(v)) {
        var arr = [];
        for (var i = 0; i < v.length; i++) {
          if (v[i] == null) continue;
          var s = String(v[i]).toLowerCase().trim();
          if (s) arr.push(s);
        }
        out[id] = arr;
      } else if (v != null) {
        var s2 = String(v).toLowerCase().trim();
        out[id] = s2 ? [s2] : [];
      } else {
        out[id] = [];
      }
    }
    return Object.freeze(out);
  } catch (e) {
    console.warn("[variantImageFilter] Failed to parse alt-image-hint-map", e);
    return Object.freeze({});
  }
})();

/* Lowercase only; normalizeSrc() lowercases URLs */
var KEYWORDS = ["lifestyle","bridge-box","imp","accessories"];

var ALLOWED_URL = [
  "/products/the-aurelius-strap",
  "/products/the-parisian-strap",
  "/products/the-monte-carlo",
  "/products/the-touring-strap",
  "/products/the-cerda-strap",
  "/products/the-venturi-strap",
  "/products/the-goodwood-strap",
  "/products/the-pelagic-strap",
  "/products/the-polaris-strap",
  "/products/the-regent-strap",
  "/products/the-polaris-strap",
  "/products/the-roger-strap",
];

var _isFiltering = false;

// Default behavior: preserve Shopify media ordering.
// Set `window.variantImageFilterReorder = true` to enable reordering.
var REORDER_ENABLED = (function(){
  try { return typeof window !== "undefined" && window.variantImageFilterReorder === true; }
  catch (e) { return false; }
})();

var DEBUG_LEVEL = (function(){
  function normalizeLevel(val) {
    if (val == null) return null;
    if (val === true) return 1;
    if (val === false) return 0;
    var str = String(val).trim().toLowerCase();
    if (str === "true" || str === "on") return 1;
    if (str === "false" || str === "off") return 0;
    var n = parseInt(str, 10);
    if (!isNaN(n)) {
      if (n < 0) return 0;
      if (n > 3) return 3;
      return n;
    }
    return null;
  }
  try {
    if (typeof window !== "undefined") {
      if (typeof window.variantImageFilterDebug === "boolean") {
        return window.variantImageFilterDebug ? 1 : 0;
      }
      if (typeof window.variantImageFilterDebug === "number") {
        var lvl = normalizeLevel(window.variantImageFilterDebug);
        if (lvl != null) return lvl;
      }
      if (window.location && window.location.search && typeof URLSearchParams === "function") {
        var params = new URLSearchParams(window.location.search);
        var qp = params.get("vifDebug") || params.get("variantImageFilterDebug");
        var lvl2 = normalizeLevel(qp || (params.has("vifDebug") ? "1" : null));
        if (lvl2 != null) return lvl2;
      }
      if (window.localStorage) {
        var stored = window.localStorage.getItem("variantImageFilterDebug");
        var lvl3 = normalizeLevel(stored);
        if (lvl3 != null) return lvl3;
      }
    }
  } catch (err) {
    console.warn("[variantImageFilter] debug flag error", err);
  }
  return 0;
})();

var DEBUG_ENABLED = DEBUG_LEVEL > 0;

function debugLog() {
  if (!DEBUG_ENABLED) return;
  var args = Array.prototype.slice.call(arguments);
  args.unshift("[variantImageFilter][debug]");
  console.log.apply(console, args);
}

function debugWarn() {
  if (!DEBUG_ENABLED) return;
  var args = Array.prototype.slice.call(arguments);
  args.unshift("[variantImageFilter][debug]");
  console.warn.apply(console, args);
}

function debugGroup(label, initialPayload) {
  if (!DEBUG_ENABLED) return function(){};
  var ended = false;
  if (console.groupCollapsed) {
    console.groupCollapsed("[variantImageFilter][debug] " + label);
  } else {
    console.log("[variantImageFilter][debug] " + label);
  }
  if (initialPayload !== undefined) console.log(initialPayload);
  return function(){
    if (ended) return;
    ended = true;
    try { console.groupEnd(); } catch (e) {}
  };
}

function debugTable(label, rows) {
  if (DEBUG_LEVEL < 2) return;
  if (!rows || !rows.length) return;
  if (console.groupCollapsed) {
    console.groupCollapsed("[variantImageFilter][debug-table] " + label);
  }
  if (console.table) {
    console.table(rows);
  } else {
    console.log(label, rows);
  }
  if (console.groupEnd) console.groupEnd();
}

function snapshotMatches(matches) {
  var out = [];
  if (!Array.isArray(matches)) return out;
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];
    if (!match) continue;
    out.push({
      key: getNodeIdentifier(match.li),
      hasKeyword: !!match.hasKeyword,
      matchesVariantImage: !!match.matchesVariantImage,
      foundInSku: !!match.foundInSku,
      delimFoundInSku: !!match.delimFoundInSku,
      altFound: !!match.altFound,
      altDelimFound: !!match.altDelimFound,
      shown: !!match._shownFlag
    });
  }
  return out;
}

function storeLastRun(payload) {
  try {
    if (typeof window !== "undefined") {
      window.variantImageFilterLastRun = payload;
    }
  } catch (e) {
    debugWarn("Failed to store last run payload", e);
  }
}

function summarizeMatches(matches, limit) {
  var out = [];
  if (!Array.isArray(matches)) return out;
  var max = typeof limit === "number" ? limit : matches.length;
  for (var i = 0; i < matches.length && i < max; i++) {
    var item = matches[i];
    out.push({
      key: getNodeIdentifier(item && item.li),
      hasKeyword: !!(item && item.hasKeyword),
      matchesVariantImage: !!(item && item.matchesVariantImage),
      foundInSku: !!(item && item.foundInSku),
      delimFoundInSku: !!(item && item.delimFoundInSku),
      altFound: !!(item && item.altFound),
      altDelimFound: !!(item && item.altDelimFound)
    });
  }
  if (matches.length > max) {
    out.push("… +" + (matches.length - max) + " more");
  }
  return out;
}

function getNodeIdentifier(node) {
  if (!node || typeof node.getAttribute !== "function") return null;
  return node.getAttribute("data-media-id") ||
    node.getAttribute("data-target") ||
    node.getAttribute("id") ||
    node.id ||
    node.className ||
    node.tagName ||
    null;
}

/**
 * Collect alternate-image hints for a variant from multiple sources:
 * - ALT_IMAGE_HINT_MAP (Liquid-injected JSON keyed by variant id)
 * - Variant metafield `custom.alternate_image_filename`
 * - Fallbacks: `variant.alternate_image_filename` or objects with `.value`
 */
function getAltHintsForVariant(variantObj) {
  function normalizeToArray(input) {
    if (input == null) return [];
    // Metafields may be: string, array, or object with `.value`
    if (typeof input === 'object' && !Array.isArray(input)) {
      if ('value' in input) return normalizeToArray(input.value);
      return [];
    }
    if (Array.isArray(input)) return input;
    // String: split on commas/semicolons or newline; keep full token too if no separators
    var s = String(input);
    if (s.indexOf(',') !== -1 || s.indexOf(';') !== -1 || /\n|\r/.test(s)) {
      return s.split(/[;,\n\r]+/);
    }
    return [s];
  }

  function pushHints(out, src) {
    var arr = normalizeToArray(src);
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == null) continue;
      var t = String(arr[i]).toLowerCase().trim();
      if (t) out.push(t);
    }
  }

  var hints = [];
  if (!variantObj) return hints;
  // 1) From Liquid-provided map
  pushHints(hints, ALT_IMAGE_HINT_MAP[String(variantObj.id)] || []);

  // 2) From metafields if present
  var mf = (variantObj.metafields || variantObj.metafield || {});
  if (mf.custom && mf.custom.alternate_image_filename != null) {
    pushHints(hints, mf.custom.alternate_image_filename);
  }
  if (mf.alternate_image_filename != null) {
    pushHints(hints, mf.alternate_image_filename);
  }

  // 3) Direct field on variant as a last resort
  if (variantObj.alternate_image_filename != null) {
    pushHints(hints, variantObj.alternate_image_filename);
  }

  return hints;
}

function getVariantFromUrl(productData) {
  var params = new URLSearchParams(window.location.search);
  var variantId = params.get("variant");
  if (!variantId || !productData || !productData.variants) return null;
  var variants = productData.variants;
  for (var i = 0; i < variants.length; i++) {
    if (String(variants[i].id) === variantId) return variants[i];
  }
  return null;
}

function getVariantFromEventOrDom(evt) {
  try {
    // 1) Prefer a full variant object on the event.
    if (evt && evt.detail) {
      if (evt.detail.variant && evt.detail.variant.id) return evt.detail.variant;
      if (evt.detail.currentVariant && evt.detail.currentVariant.id) return evt.detail.currentVariant;
      if (evt.detail.data && evt.detail.data.variant && evt.detail.data.variant.id) return evt.detail.data.variant;
    }

    // 2) Resolve variant id from common DOM sources.
    var variantId = null;
    if (evt && evt.detail && (evt.detail.variantId || evt.detail.id)) {
      variantId = evt.detail.variantId || evt.detail.id;
    }
    if (!variantId) {
      // Most reliable: current add-to-cart input
      var idInput = document.querySelector('form[action^="/cart/add"] input[name="id"]');
      if (idInput && idInput.value) variantId = idInput.value;
    }
    if (!variantId && window.location && window.location.search) {
      var params = new URLSearchParams(window.location.search);
      variantId = params.get("variant");
    }

    // 3) Look up variant object from variant-selects if available (best data shape).
    var vs = document.querySelector("variant-selects");
    if (vs) {
      if (vs.currentVariant && String(vs.currentVariant.id) === String(variantId || vs.currentVariant.id)) {
        return vs.currentVariant;
      }
      if (typeof vs.getVariantData === "function" && variantId) {
        var vData = vs.getVariantData() || [];
        for (var i = 0; i < vData.length; i++) {
          if (String(vData[i].id) === String(variantId)) return vData[i];
        }
      }
    }

    // 4) Fallback: product data if present (used by initial-load logic).
    var productData = window.essentialCountdownTimerMeta && window.essentialCountdownTimerMeta.productData;
    if (productData && productData.variants && variantId) {
      for (var j = 0; j < productData.variants.length; j++) {
        if (String(productData.variants[j].id) === String(variantId)) return productData.variants[j];
      }
    }
  } catch (e) {}
  return null;
}

function attachVariantEventListeners() {
  if (attachVariantEventListeners._attached) return;
  attachVariantEventListeners._attached = true;

  function handler(evt) {
    try {
      var v = getVariantFromEventOrDom(evt);
      if (v) window.requestAnimationFrame(function(){ filterImages(v); });
    } catch (e) {}
  }

  // Covers Dawn (`variant:change`) and apps like Swatch King.
  ["variant:change", "variantChange", "vsk:product:variant:changed"].forEach(function(type){
    document.addEventListener(type, handler, true);
  });
}

/**
 * reorderViewer(variantObj)
 */
function reorderViewer(variantObj) {
  if (!variantObj) return;

  var variantMainSrc = null;
  if (variantObj.featured_media && variantObj.featured_media.src) {
    variantMainSrc = normalizeSrc(variantObj.featured_media.src);
  }
  var variantSku = (variantObj.sku || "").toLowerCase();
  var altHints = getAltHintsForVariant(variantObj);

  var nodes = document.querySelectorAll(
    ".product__media-list li.product__media-item[data-media-id]:not(.always-hide)"
  );
  var listItems = Array.prototype.slice.call(nodes);

  var sortable = [];
  for (var i = 0; i < listItems.length; i++) {
    var li = listItems[i];
    var mediaSrc = getMediaSrc(li);
    var mediaAlt = getAltText(li);
    var group = 999, keywordIndex = 999;

    if (mediaSrc) {
      var m = findMatches(variantSku, variantMainSrc, mediaSrc, altHints, mediaAlt);
      if (m.matchesVariantImage) {
        group = 1;
      } else if (m.foundInSku || m.altFound || m.altTextFoundInSku) {
        group = 2;
      } else if (m.delimFoundInSku || m.altDelimFound || m.altTextDelimFound) {
        group = 3;
      } else if (m.hasKeyword) {
        group = 4;
        var srcNorm = normalizeSrc(mediaSrc);
        for (var k = 0; k < KEYWORDS.length; k++) {
          if (srcNorm.indexOf(KEYWORDS[k]) !== -1) { keywordIndex = k; break; }
        }
      }
    }

    sortable.push({
      li: li,
      group: group,
      keywordIndex: keywordIndex,
      originalIndex: i
    });
  }

  sortable.sort(function(a, b) {
    if (a.group !== b.group) return a.group - b.group;
    if (a.keywordIndex !== b.keywordIndex) return a.keywordIndex - b.keywordIndex;
    return a.originalIndex - b.originalIndex;
  });

  var ul = document.querySelector(".product__media-list");
  for (var j = 0; j < sortable.length; j++) {
    ul.appendChild(sortable[j].li);
  }
}

/**
 * reorderThumbnails(variantObj)
 */
function reorderThumbnails(variantObj) {
  if (!variantObj) return;

  var variantMainSrc = null;
  if (variantObj.featured_media && variantObj.featured_media.src) {
    variantMainSrc = normalizeSrc(variantObj.featured_media.src);
  }
  var variantSku = (variantObj.sku || "").toLowerCase();
  var altHints = getAltHintsForVariant(variantObj);

  var nodes = document.querySelectorAll(
    ".thumbnail-list .thumbnail-list__item.slider__slide:not(.always-hide)"
  );
  var listItems = Array.prototype.slice.call(nodes);

  var sortable = [];
  for (var i = 0; i < listItems.length; i++) {
    var li = listItems[i];
    var mediaSrc = getMediaSrc(li);
    var mediaAlt = getAltText(li);
    var group = 999, keywordIndex = 999;

    if (mediaSrc) {
      var m = findMatches(variantSku, variantMainSrc, mediaSrc, altHints, mediaAlt);
      if (m.matchesVariantImage) {
        group = 1;
      } else if (m.foundInSku || m.altFound || m.altTextFoundInSku) {
        group = 2;
      } else if (m.delimFoundInSku || m.altDelimFound || m.altTextDelimFound) {
        group = 3;
      } else if (m.hasKeyword) {
        group = 4;
        var srcNorm = normalizeSrc(mediaSrc);
        for (var k = 0; k < KEYWORDS.length; k++) {
          if (srcNorm.indexOf(KEYWORDS[k]) !== -1) { keywordIndex = k; break; }
        }
      }
    }

    sortable.push({ li: li, group: group, keywordIndex: keywordIndex, originalIndex: i });
  }

  sortable.sort(function(a, b) {
    if (a.group !== b.group) return a.group - b.group;
    if (a.keywordIndex !== b.keywordIndex) return a.keywordIndex - b.keywordIndex;
    return a.originalIndex - b.originalIndex;
  });

  var container = document.querySelector(".thumbnail-list");
  for (var j = 0; j < sortable.length; j++) {
    container.appendChild(sortable[j].li);
  }
}

/** normalizeSrc */
function normalizeSrc(src) {
  var noQuery = src.split("?")[0];
  noQuery = noQuery.replace(/^https?:\/\/[^\/]+/, "");
  return noQuery.toLowerCase();
}

/** getMediaSrc: resolve media URL for images or videos */
function getMediaSrc(root) {
  if (!root) return null;
  // 1) Prefer visible <img> (covers image media and video posters)
  var img = root.querySelector("img");
  if (img && img.src) return img.src;

  // 2) Handle <video> or nested <source>
  var video = root.querySelector("video");
  if (video) {
    if (video.currentSrc) return video.currentSrc;
    if (video.getAttribute && video.getAttribute("src")) return video.getAttribute("src");
    var vSource = video.querySelector("source[src]");
    if (vSource && vSource.src) return vSource.src;
  }

  // 3) Fallback: any <source> under root
  var anySource = root.querySelector("source[src]");
  if (anySource && anySource.src) return anySource.src;

  // 4) Last resort: video poster attribute (may be an image URL)
  if (video && (video.poster || video.getAttribute("poster"))) {
    return video.poster || video.getAttribute("poster");
  }
  return null;
}

function isNonImageViewerSlide(li) {
  if (!li) return false;
  if (li.classList && li.classList.contains("product__media-item--full")) return true;
  // Dawn uses deferred-media/product-model wrappers for video/model media.
  if (li.querySelector && li.querySelector("deferred-media, product-model")) return true;
  if (li.querySelector && li.querySelector("video, model-viewer, iframe")) return true;
  return false;
}

function isNonImageThumbnail(li) {
  if (!li) return false;
  // Dawn thumbnail list renders a badge for video/model thumbnails.
  if (li.querySelector && li.querySelector(".thumbnail__badge")) return true;

  // Featured media thumbnail does not always have a badge; infer from its target slide.
  var target = li.getAttribute && li.getAttribute("data-target");
  if (target && typeof document !== "undefined") {
    var root = (li.closest && li.closest("media-gallery")) || document;
    var slide = root.querySelector('.slider__slide[data-media-id="' + target + '"]');
    if (slide && isNonImageViewerSlide(slide)) return true;
  }
  return false;
}

/** getAltText: extract useful per-element label (e.g., thumbnail img alt) */
function getAltText(root) {
  if (!root) return null;
  var img = root.querySelector('img[alt]');
  if (img && typeof img.alt === 'string' && img.alt.trim()) return img.alt;

  // For viewer slides (especially videos), the preview image alt can be empty even when
  // the media alt is set. Thumbnails usually have the correct `media.alt`, so fall back
  // to the matching thumbnail's <img alt="..."> using data-media-id/data-target.
  try {
    var mediaId = (root.getAttribute && root.getAttribute("data-media-id")) || null;
    if (mediaId && root.closest) {
      var gallery = root.closest("media-gallery");
      if (gallery) {
        var thumb = gallery.querySelector('[data-target="' + mediaId + '"] img[alt]');
        if (thumb && typeof thumb.alt === "string" && thumb.alt.trim()) return thumb.alt;
      }
    }
  } catch (e) {}

  // Fallbacks if needed
  var labelled = root.getAttribute && root.getAttribute('aria-label');
  if (labelled && labelled.trim()) return labelled;
  return null;
}

/** parseBareFilename */
function parseBareFilename(imgUrl) {
  var noParams = imgUrl.split("?")[0];
  var segments = noParams.split("/");
  var filename = segments[segments.length - 1] || "";
  filename = filename.replace(/\.[^/.]+$/, "");
  // Remove common Shopify CDN size suffixes like _2000x
  filename = filename.replace(/_[0-9]+x$/i, "");
  // Strip UUID/hash-like tails e.g. -19_d6cc9e31-2bea-4da8-8e74-45ba10287980
  filename = filename.replace(/(?:-\d+)?_[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i, "");
  // Also strip trailing hyphen-UUID or long hex tails if present
  filename = filename.replace(/-[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i, "");
  filename = filename.replace(/-[0-9a-f]{12,}$/i, "");
  // Remove simple numeric suffixes like -19
  filename = filename.replace(/-\d+$/, "");
  // Remove TBW- prefix in any segment (start or after __)
  filename = filename.replace(/\btbw-/gi, "");
  // Normalize leftover multiple dashes
  filename = filename.replace(/--+/g, "-");
  return filename.toLowerCase();
}

function normalizeComparable(str) {
  if (str == null) return "";
  // Normalize common separators so alt text like "TBW_CERD_NAVY_2" matches "TBW-CERD-NAVY-2".
  var s = String(str).toLowerCase().trim();
  s = s.replace(/\btbw[-_ ]/g, ""); // drop TBW- prefix for matching
  s = s.replace(/[^a-z0-9]+/g, "-");
  s = s.replace(/-+/g, "-").replace(/^-|-$/g, "");
  return s;
}

function parsePinnedAltDirective(altText) {
  // Format: "<pattern>/<index>" where pattern may optionally end with '*'.
  // Example: "TBW-CERD-RED/2" -> pattern "tbw-cerd-red*" at index 1 (1-based input).
  if (!altText) return null;
  var raw = String(altText).trim();
  var m = raw.match(/^(.*)\/(\d+)\s*$/);
  if (!m) return null;
  var patternRaw = (m[1] || "").trim();
  var idxRaw = parseInt(m[2], 10);
  if (!patternRaw || isNaN(idxRaw) || idxRaw < 1) return null;
  var idx = idxRaw - 1;

  // Implicit wildcard as requested (treat PATTERN as PATTERN*).
  if (patternRaw.indexOf("*") === -1) patternRaw = patternRaw + "*";

  var hasWildcard = /\*$/.test(patternRaw);
  var prefix = patternRaw.replace(/\*+$/, "");
  var prefixNorm = normalizeComparable(prefix);
  if (!prefixNorm) return null;

  return { prefixNorm: prefixNorm, index: idx, hasWildcard: hasWildcard };
}

function pinnedDirectiveMatches(directive, variantKeyNorm, variantObj) {
  if (!directive) return false;
  var keys = [];
  if (variantKeyNorm) keys.push(String(variantKeyNorm));
  try {
    if (variantObj) {
      // Keep pin matching focused on colour identity only.
      // Including buckle/title text can incorrectly match colour-pinned media
      // when buckle option is "Black".
      var skuRaw = String(variantObj.sku || "");
      var skuBase = skuRaw.split("$")[0];
      var skuNorm = normalizeComparable(skuBase || skuRaw);
      if (skuNorm) keys.push(skuNorm);
      var option1 = variantObj.option1 || (Array.isArray(variantObj.options) ? variantObj.options[0] : "");
      var option1Norm = normalizeComparable(option1 || "");
      if (option1Norm) keys.push(option1Norm);
    }
  } catch (e) {}

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!key) continue;
    if (directive.hasWildcard) {
      if (key.indexOf(directive.prefixNorm) === 0 || key.indexOf(directive.prefixNorm) !== -1) return true;
    } else if (key === directive.prefixNorm) {
      return true;
    }
  }
  return false;
}

/** findMatches with altHints and element alt-text support */
function findMatches(variantSku, variantMainSrc, rawSrc, altHints, elementAltText) {
  var baseSrc = normalizeSrc(rawSrc);
  var skuNorm = normalizeComparable(variantSku);

  // A) keyword
  var hasKeyword = false;
  for (var i = 0; i < KEYWORDS.length; i++) {
    if (baseSrc.indexOf(KEYWORDS[i]) !== -1) { hasKeyword = true; break; }
  }

  // B) exact featured image
  var matchesVariantImage = !!variantMainSrc && baseSrc === variantMainSrc;

  // C) filename-based
  var bareName = parseBareFilename(rawSrc);
  var foundInSku = (bareName.indexOf("__") === -1) && (skuNorm.indexOf(normalizeComparable(bareName)) !== -1);

  var delimFoundInSku = false;
  if (bareName.indexOf("__") !== -1) {
    var parts = bareName.split("__");
    if (parts.length) {
      delimFoundInSku = true;
      for (var j = 0; j < parts.length; j++) {
        if (skuNorm.indexOf(normalizeComparable(parts[j])) === -1) { delimFoundInSku = false; break; }
      }
    }
  }

  // D) alt hints (from metafields/Liquid JSON)
  var altFound = false;
  var altDelimFound = false;
  if (Array.isArray(altHints) && altHints.length) {
    function cleanHintToken(s) {
      return String(s).toLowerCase().trim().replace(/\btbw-/g, "");
    }
    for (var a = 0; a < altHints.length; a++) {
      var hint = altHints[a];
      if (!hint) continue;

      var hintClean = cleanHintToken(hint);
      if (!hintClean) continue;

      if (bareName.indexOf(hintClean) !== -1 || baseSrc.indexOf("/" + hintClean) !== -1) {
        altFound = true;
        break;
      }

      if (hintClean.indexOf("__") !== -1) {
        var hParts = hintClean.split("__");
        if (hParts.length) {
          var allIn = true;
          for (var hp = 0; hp < hParts.length; hp++) {
            if (bareName.indexOf(hParts[hp]) === -1) { allIn = false; break; }
          }
          if (allIn) altDelimFound = true;
        }
      }
    }
  }

  // E) element alt-text (e.g., video thumbnail's <img alt="TBW-...")
  var altTextFoundInSku = false;
  var altTextDelimFound = false;
  if (elementAltText) {
    // Strip optional pin directive suffix "/<index>" before tokenizing, otherwise parseBareFilename
    // would treat the last path segment (the index) as the "filename".
    var altRaw = String(elementAltText).trim();
    altRaw = altRaw.replace(/\/(\d+)\s*$/, "");
    var altClean = altRaw.toLowerCase().trim();
    var altToken = parseBareFilename(altClean);
    if (altToken) {
      if (altToken.indexOf("__") === -1) {
        altTextFoundInSku = (skuNorm.indexOf(normalizeComparable(altToken)) !== -1);
        // Fallback: if the full token doesn't match (common when variant SKU isn't set),
        // require at least two meaningful token matches to avoid false positives from
        // shared model tokens (e.g. "cerd" matching every Cerda variant).
        if (!altTextFoundInSku && skuNorm) {
          var parts = normalizeComparable(altToken).split("-");
          var meaningfulCount = 0;
          var matchedCount = 0;
          for (var p = 0; p < parts.length; p++) {
            var part = parts[p];
            if (!part) continue;
            if (/^\d+$/.test(part)) continue;
            if (part.length < 3) continue;
            if (part === "tbw") continue;
            meaningfulCount++;
            if (skuNorm.indexOf(part) !== -1) matchedCount++;
          }
          if (meaningfulCount > 0) {
            altTextFoundInSku = matchedCount >= Math.min(2, meaningfulCount);
          }
        }
      } else {
        var aParts = altToken.split("__");
        if (aParts.length) {
          altTextDelimFound = true;
          for (var ap = 0; ap < aParts.length; ap++) {
            if (skuNorm.indexOf(normalizeComparable(aParts[ap])) === -1) { altTextDelimFound = false; break; }
          }
        }
      }
    }
  }

  return {
    hasKeyword: hasKeyword,
    matchesVariantImage: matchesVariantImage,
    foundInSku: foundInSku,
    delimFoundInSku: delimFoundInSku,
    altFound: altFound,
    altDelimFound: altDelimFound,
    altTextFoundInSku: altTextFoundInSku,
    altTextDelimFound: altTextDelimFound
  };
}

/* ====================================
 * 3) filterImages()
 * ==================================== */
function filterImages(variantObj) {
  if (!variantObj) {
    debugWarn("filterImages invoked without variant data");
    return;
  }
  if (_isFiltering) return;
  _isFiltering = true;
  var endGroup = debugGroup("filterImages variant " + (variantObj && variantObj.id));
  try {
    var variantMainSrc = (variantObj.featured_media && variantObj.featured_media.src)
      ? normalizeSrc(variantObj.featured_media.src)
      : null;
    // Two matching contexts:
    // - Images: full variant identity (includes buckle/size) so non-selected hardware images hide.
    // - Videos: colour-focused identity to avoid buckle text (e.g., "Black") matching colour videos.
    var option1 = variantObj.option1 || (Array.isArray(variantObj.options) ? variantObj.options[0] : "");
    var skuRaw = String(variantObj.sku || "");
    var skuBase = skuRaw.split("$")[0] || skuRaw;
    var variantSkuColor = (skuBase + " " + (option1 || "")).toLowerCase();
    var variantSkuImage = (skuRaw || variantSkuColor).toLowerCase();
    var variantKeyNorm = normalizeComparable(variantSkuColor);
    var altHints = getAltHintsForVariant(variantObj);
    debugLog("Variant context", {
      id: variantObj.id,
      skuColor: variantSkuColor,
      skuImage: variantSkuImage,
      altHintCount: altHints.length,
      hasFeaturedMedia: !!variantMainSrc
    });

    // Thumbnails (support both theme structures)
    var tNodes = document.querySelectorAll(
      ".thumbnail-list .thumbnail-list__item.slider__slide, .thumbnail-slider li"
    );
    var thumbnailMatches = [];
    var i;
    for (i = 0; i < tNodes.length; i++) {
      var li = tNodes[i];
      var isNonImage = isNonImageThumbnail(li);
      var tSrc = getMediaSrc(li);
      var tAlt = getAltText(li);
      if (!tSrc && !isNonImage) continue;
      var tPin = parsePinnedAltDirective(tAlt);
      var tPinMatch = pinnedDirectiveMatches(tPin, variantKeyNorm, variantObj);
      var tVariantSku = isNonImage ? variantSkuColor : variantSkuImage;
      var m = tSrc
        ? findMatches(tVariantSku, variantMainSrc, tSrc, altHints, tAlt)
        : {
            hasKeyword: false,
            matchesVariantImage: false,
            foundInSku: false,
            delimFoundInSku: false,
            altFound: false,
            altDelimFound: false,
            altTextFoundInSku: false,
            altTextDelimFound: false
          };
      thumbnailMatches.push({
        li: li,
        isNonImage: isNonImage,
        pin: tPin,
        pinMatch: tPinMatch,
        hasKeyword: m.hasKeyword,
        matchesVariantImage: m.matchesVariantImage,
        foundInSku: (m.foundInSku || m.altTextFoundInSku),
        delimFoundInSku: (m.delimFoundInSku || m.altTextDelimFound),
        altFound: m.altFound,
        altDelimFound: m.altDelimFound
      });
    }
    debugLog("Thumbnail matches", summarizeMatches(thumbnailMatches, 10));

    var hasThumbnailDelimiter = false;
    for (i = 0; i < thumbnailMatches.length; i++) {
      if (thumbnailMatches[i].delimFoundInSku || thumbnailMatches[i].altDelimFound) {
        hasThumbnailDelimiter = true; break;
      }
    }
    if (!thumbnailMatches.length) {
      debugWarn("No thumbnail nodes located for variant", variantObj.id);
    }

    var shownThumbCount = 0;
    var shownThumbnailIds = Object.create(null);
    var firstShownThumbnailMediaId = null;
    for (i = 0; i < thumbnailMatches.length; i++) {
      var tm = thumbnailMatches[i];
      // If *any* image uses delimiter matching, keep that stricter logic for images.
      // For non-image media (video/model), prefer SKU/alt matching even in delimiter mode
      // since hosted video preview filenames are often opaque hashes.
      var canShowBase = (tm.pinMatch || tm.hasKeyword || tm.matchesVariantImage || tm.foundInSku || tm.altFound);
      var canShowDelim = (tm.pinMatch || tm.hasKeyword || tm.matchesVariantImage || tm.delimFoundInSku || tm.altDelimFound);
      var canShow = tm.isNonImage ? canShowBase : (hasThumbnailDelimiter ? canShowDelim : canShowBase);
      if (canShow) {
        tm.li.style.display = "list-item";
        tm.li.classList.remove("always-hide");
        tm._shownFlag = true;
        shownThumbCount++;
        var shownMediaId = tm.li.getAttribute && (tm.li.getAttribute("data-target") || tm.li.getAttribute("data-media-id"));
        if (shownMediaId) {
          shownThumbnailIds[shownMediaId] = true;
          if (!firstShownThumbnailMediaId) firstShownThumbnailMediaId = shownMediaId;
        }
      } else {
        tm.li.style.display = "none";
        tm.li.classList.add("always-hide");
        tm._shownFlag = false;
      }
    }
    debugLog("Thumbnail visibility", {
      total: thumbnailMatches.length,
      shown: shownThumbCount,
      usedDelimiter: hasThumbnailDelimiter
    });
    if (thumbnailMatches.length && shownThumbCount === 0) {
      debugWarn("All thumbnails hidden for variant", variantObj.id, summarizeMatches(thumbnailMatches, 6));
      // Safety fallback: never leave the product with no selectable media.
      for (i = 0; i < thumbnailMatches.length; i++) {
        var tmFallback = thumbnailMatches[i];
        tmFallback.li.style.display = "list-item";
        tmFallback.li.classList.remove("always-hide");
        tmFallback._shownFlag = true;
        var fallbackMediaId = tmFallback.li.getAttribute && (tmFallback.li.getAttribute("data-target") || tmFallback.li.getAttribute("data-media-id"));
        if (fallbackMediaId) {
          shownThumbnailIds[fallbackMediaId] = true;
          if (!firstShownThumbnailMediaId) firstShownThumbnailMediaId = fallbackMediaId;
        }
      }
      shownThumbCount = thumbnailMatches.length;
      debugWarn("Thumbnail fallback activated; restored all thumbnails", {
        variant: variantObj.id,
        restored: shownThumbCount
      });
    }
    debugTable("Thumbnail matches", snapshotMatches(thumbnailMatches));

    // Viewer Images
    var vNodes = document.querySelectorAll(".slider__slide[data-media-id]");
    var viewerMatches = [];
    for (i = 0; i < vNodes.length; i++) {
      li = vNodes[i];
      var isNonImageV = isNonImageViewerSlide(li);
      var vSrc = getMediaSrc(li);
      var vAlt = getAltText(li);
      if (!vSrc && !isNonImageV) continue;
      var vPin = parsePinnedAltDirective(vAlt);
      var vPinMatch = pinnedDirectiveMatches(vPin, variantKeyNorm, variantObj);
      var vVariantSku = isNonImageV ? variantSkuColor : variantSkuImage;
      m = vSrc
        ? findMatches(vVariantSku, variantMainSrc, vSrc, altHints, vAlt)
        : {
            hasKeyword: false,
            matchesVariantImage: false,
            foundInSku: false,
            delimFoundInSku: false,
            altFound: false,
            altDelimFound: false,
            altTextFoundInSku: false,
            altTextDelimFound: false
          };
      viewerMatches.push({
        li: li,
        isNonImage: isNonImageV,
        pin: vPin,
        pinMatch: vPinMatch,
        hasKeyword: m.hasKeyword,
        matchesVariantImage: m.matchesVariantImage,
        foundInSku: (m.foundInSku || m.altTextFoundInSku),
        delimFoundInSku: (m.delimFoundInSku || m.altTextDelimFound),
        altFound: m.altFound,
        altDelimFound: m.altDelimFound
      });
    }
    debugLog("Viewer matches", summarizeMatches(viewerMatches, 10));

    var hasViewerDelimiter = false;
    for (i = 0; i < viewerMatches.length; i++) {
      if (viewerMatches[i].delimFoundInSku || viewerMatches[i].altDelimFound) {
        hasViewerDelimiter = true; break;
      }
    }
    if (!viewerMatches.length) {
      debugWarn("No viewer slides located for variant", variantObj.id);
    }

    var firstShown = null;
    var shownViewerCount = 0;
    for (i = 0; i < viewerMatches.length; i++) {
      var vm = viewerMatches[i];
      var vmMediaId = vm.li.getAttribute && vm.li.getAttribute("data-media-id");
      var canShowBase2 = (vm.pinMatch || vm.hasKeyword || vm.matchesVariantImage || vm.foundInSku || vm.altFound);
      var canShowDelim2 = (vm.pinMatch || vm.hasKeyword || vm.matchesVariantImage || vm.delimFoundInSku || vm.altDelimFound);
      var canShowFromThumb = !!(vmMediaId && shownThumbnailIds[vmMediaId]);
      var canShow2 = (vm.isNonImage ? canShowBase2 : (hasViewerDelimiter ? canShowDelim2 : canShowBase2)) || canShowFromThumb;

      if (canShow2) {
        vm.li.classList.remove("always-hide");
        if (!firstShown) firstShown = vm.li;
        vm._shownFlag = true;
        shownViewerCount++;
      } else {
        vm.li.classList.add("always-hide");
        vm._shownFlag = false;
      }
      vm.li.classList.remove("is-active");
    }
    if (firstShownThumbnailMediaId) {
      var preferredFirstShown = document.querySelector('.slider__slide[data-media-id="' + firstShownThumbnailMediaId + '"]:not(.always-hide)');
      if (preferredFirstShown) firstShown = preferredFirstShown;
    }
    debugLog("Viewer visibility", {
      total: viewerMatches.length,
      shown: shownViewerCount,
      usedDelimiter: hasViewerDelimiter
    });
    if (viewerMatches.length && shownViewerCount === 0) {
      debugWarn("All viewer slides hidden for variant", variantObj.id, summarizeMatches(viewerMatches, 6));
      // Safety fallback: keep gallery visible if matching heuristics fail for this variant payload.
      for (i = 0; i < viewerMatches.length; i++) {
        var vmFallback = viewerMatches[i];
        vmFallback.li.classList.remove("always-hide");
        vmFallback._shownFlag = true;
      }
      shownViewerCount = viewerMatches.length;
      firstShown = viewerMatches[0].li;
      debugWarn("Viewer fallback activated; restored all viewer slides", {
        variant: variantObj.id,
        restored: shownViewerCount
      });
    }
    debugTable("Viewer matches", snapshotMatches(viewerMatches));
    if (firstShown) {
      // Use MediaGallery API so deferred video/model content loads correctly.
      var gallery = (firstShown.closest && firstShown.closest("media-gallery")) || null;
      var mediaId = firstShown.getAttribute && firstShown.getAttribute("data-media-id");
      if (gallery && typeof gallery.setActiveMedia === "function" && mediaId) {
        gallery.setActiveMedia(mediaId, false);
      } else {
        firstShown.classList.add("is-active");
      }
    } else if (viewerMatches.length) {
      debugWarn("No viewer slide chosen as active", {
        variant: variantObj.id,
        matches: summarizeMatches(viewerMatches, 8)
      });
    }

    // Reorder (opt-in). By default we preserve Shopify dashboard ordering.
    if (REORDER_ENABLED) {
      reorderViewer(variantObj);
      reorderThumbnails(variantObj);
    }

    // Pin media to explicit indices based on alt directives like "TBW-CERD-RED/2".
    // Applied after filtering and before slider reset.
    try {
      function moveToShownIndex(container, el, index) {
        if (!container || !el || typeof index !== "number") return;
        var shown = Array.prototype.slice.call(container.children).filter(function(n){
          return n && !n.classList.contains("always-hide") && !(n.style && n.style.display === "none");
        });
        // Recompute without this element
        shown = shown.filter(function(n){ return n !== el; });
        var clamped = index;
        if (clamped < 0) clamped = 0;
        if (clamped > shown.length) clamped = shown.length;
        if (clamped === shown.length) {
          container.appendChild(el);
        } else {
          container.insertBefore(el, shown[clamped]);
        }
      }

      var viewerContainer = document.querySelector(".product__media-list");
      var thumbContainer = document.querySelector(".thumbnail-list");

      var pinnedViewer = viewerMatches
        .filter(function(vm){ return vm && vm.pinMatch && vm.pin && vm._shownFlag; })
        .sort(function(a, b){ return (a.pin.index - b.pin.index) || 0; });
      for (var pv = 0; pv < pinnedViewer.length; pv++) {
        moveToShownIndex(viewerContainer, pinnedViewer[pv].li, pinnedViewer[pv].pin.index);
      }

      var pinnedThumbs = thumbnailMatches
        .filter(function(tm){ return tm && tm.pinMatch && tm.pin && tm._shownFlag; })
        .sort(function(a, b){ return (a.pin.index - b.pin.index) || 0; });
      for (var pt = 0; pt < pinnedThumbs.length; pt++) {
        moveToShownIndex(thumbContainer, pinnedThumbs[pt].li, pinnedThumbs[pt].pin.index);
      }
    } catch (e) {}

    // After hiding/showing thumbnails, the slider buttons can get stuck disabled.
    // Reset paging and scroll back to the start so index 1/2 are reachable.
    try {
      var mg = (typeof window !== "undefined" && window.mediaGal) ? window.mediaGal : null;
      var thumbsSlider = mg && mg.elements && mg.elements.thumbnails;
      if (thumbsSlider && thumbsSlider.slider) {
        thumbsSlider.slider.scrollLeft = 0;
      }
      if (thumbsSlider && typeof thumbsSlider.resetPages === "function") {
        thumbsSlider.resetPages();
      }
    } catch (e) {}

    storeLastRun({
      variantId: variantObj.id,
      timestamp: Date.now(),
      debugLevel: DEBUG_LEVEL,
      thumbnails: {
        total: thumbnailMatches.length,
        shown: shownThumbCount,
        hasDelimiter: hasThumbnailDelimiter,
        matches: snapshotMatches(thumbnailMatches)
      },
      viewer: {
        total: viewerMatches.length,
        shown: shownViewerCount,
        hasDelimiter: hasViewerDelimiter,
        matches: snapshotMatches(viewerMatches)
      }
    });

  } finally {
    if (typeof endGroup === "function") endGroup();
    _isFiltering = false;
  }
}

function patchVariantSelects() {
  var MAX_ATTEMPTS = 30, attempts = 0;
  (function tryPatch(){
    attempts++;
    var VS = customElements.get("variant-selects");
    if (!VS || !VS.prototype) {
      if (attempts < MAX_ATTEMPTS) setTimeout(tryPatch, 200);
      return;
    }

    var globalDepth = 0;

    // 1) updateMedia
    if (!VS.prototype.updateMedia._patchedByImageFilter) {
      var originalUM = VS.prototype.updateMedia;
      VS.prototype.updateMedia = function(){
        if (globalDepth > 0) return;
        globalDepth++;
        try {
          var out = originalUM.apply(this, arguments);
          var v = this.currentVariant;
          if (v) window.requestAnimationFrame(function(){ filterImages(v); });
          return out;
        } finally {
          globalDepth--;
        }
      };
      VS.prototype.updateMedia._patchedByImageFilter = true;
      console.log("[variantImageFilter] updateMedia patched");
    }

    // 2) updateVariantInput
    if (!VS.prototype.updateVariantInput._patchedByImageFilter) {
      var originalVI = VS.prototype.updateVariantInput;
      VS.prototype.updateVariantInput = function(){
        if (globalDepth > 0) return;
        globalDepth++;
        try {
          // Preserve Dawn behavior (including input change dispatch) since other widgets
          // may rely on it (e.g. additional option toggles).
          return originalVI && originalVI.apply(this, arguments);
        } finally {
          globalDepth--;
        }
      };
      VS.prototype.updateVariantInput._patchedByImageFilter = true;
      console.log("[variantImageFilter] updateVariantInput patched");
    }

    // 3) Swatch King dispatchEvent
    (function patchVSK(){
      var vsk = window.VariantSwatchKing || {};
      if (!vsk.dispatchEvent || vsk.dispatchEvent._patched_v4) return;
      var originalDispatch = vsk.dispatchEvent;
      vsk.dispatchEvent = function(type, target){
        if ((target && target.__vskDispatching) || (!target && globalDepth > 0)) return;
        globalDepth++;
        if (target) target.__vskDispatching = true;
        try {
          return originalDispatch.apply(this, arguments);
        } finally {
          globalDepth--;
          if (target) delete target.__vskDispatching;
        }
      };
      vsk.dispatchEvent._patched_v4 = true;
      console.log("[variantImageFilter] VSK dispatchEvent patched v4");
    })();

    // re-patch on load
    window.addEventListener("load", function(){
      setTimeout(patchVariantSelects, 0);
    });

  })();
}

/* ====================================
 * 5) Bootstrap once gallery exists
 * ==================================== */
function waitForDataThenFire() {
  var MAX_ATTEMPTS = 100, tries = 0;
  var poll = setInterval(function(){
    tries++;
    var mediaGal = document.querySelector(".product__media-gallery");
    if (mediaGal && mediaGal.elements) {
      clearInterval(poll);
      window.mediaGal = mediaGal;
      window.thumbnails = mediaGal.elements.thumbnails;
      window.viewer = mediaGal.elements.viewer;
      attachVariantEventListeners();
      patchVariantSelects();
      // Run once on load for the currently selected variant.
      // Prefer live VariantSelects data; fallback to URL+productData if available.
      try {
        var vs = document.querySelector("variant-selects");
        var v0 = vs && vs.currentVariant;
        if (v0) {
          filterImages(v0);
        } else {
          var productData = window.essentialCountdownTimerMeta && window.essentialCountdownTimerMeta.productData;
          var variant = getVariantFromUrl(productData);
          if (variant) filterImages(variant);
        }
      } catch (e) {}
      return;
    }
    if (tries >= MAX_ATTEMPTS) {
      clearInterval(poll);
      console.warn("[variantImageFilter] media gallery not found – aborting.");
    }
  }, 20);
}


/* Kick-off only on whitelisted product URLs */
(function(){
  for (var i = 0; i < ALLOWED_URL.length; i++) {
    if (location.pathname.indexOf(ALLOWED_URL[i]) !== -1) {
      // Attach as early as possible so we don't miss initial variant-change events.
      attachVariantEventListeners();
      waitForDataThenFire();
      return;
    }
  }
  console.info("[variantImageFilter] disabled for this product.");
})();
